module.exports = __webpack_public_path__ + "img/video-guochan.21c068da.jpg";